import { combineReducers } from "redux";
import cachedDataReducer from "./cachedDataReducer";
import fetchedSelectionsReducer from "./fetchedSelectionsReducer";
import filePreviewReducer from "./filePreviewReducer";
import loanDrilldownReducer from "./loanDrilldownReducer";
import loanPipelineReducer from "./loanPipelineReducer";
import navSidebarReducer from "./navSidebarReducer";
import pipelineReducer from "./pipelineReducer";
import sidebarReducer from "./sidebarReducer";
import userReducer from "./userReducer";
import usersReducer from "./usersReducer";
import workspaceTabsReducer from "./workspaceTabsReducer";
import loanFetchedDataReducer from "./loanFetchedDataReducer";
import modalReducer from "./modalReducer";
import detailSidebarReducer from "./detailSidebarReducer";
import notificationsReducer from "./notificationsReducer";
import docUploadModalReducer from "./docUploadModalReducer";

const rootReducer = combineReducers({
  cachedData: cachedDataReducer,
  user: userReducer,
  modal: modalReducer,
  navSidebar: navSidebarReducer,
  loanDrilldown: loanDrilldownReducer,
  loanPipeline: loanPipelineReducer,
  sidebar: sidebarReducer,
  detailSidebar: detailSidebarReducer,
  loanFetchedData: loanFetchedDataReducer,
  filePreview: filePreviewReducer,
  fetchedSelections: fetchedSelectionsReducer,
  users: usersReducer,
  pipeline: pipelineReducer,
  workspaceTabs: workspaceTabsReducer,
  notifications: notificationsReducer,
  docUploadModal: docUploadModalReducer,
});

export default rootReducer;
